import {
  ReceiptPrinterClient,
  ReceiptPrinterModes,
  LabelAvailablePrinters,
  LabelPrinterClient,
  setup,
  SupportedServices,
  ReceiptPrinterClientProps,
  LabelPrinterClientProps,
  MockFormat,
} from 'postoffice-peripheral-management-service';
import { compile } from 'postoffice-receipt-generator';

import { getEnvVar } from '@utils/environmentVariables';

export type PrinterType = 'label' | 'receipt';

export interface Receipt {
  template: string;
  context?: Record<string, unknown>;
}

export type PrintMode = 'FirstPrint' | 'Reprint';

export const POL_PRINTER_DEVICE_SERVER_HOST = 'ws://localhost:2001/nbit-server';
export const deviceServerSimulated =
  getEnvVar('NEXT_PUBLIC_POL_DEVICE_SERVER_SIMULATED') === 'true';

const printingService = setup({
  deviceServerHost: POL_PRINTER_DEVICE_SERVER_HOST,
});

const labelPrinterClient = printingService.buildClient(SupportedServices.LabelPrinter, {
  useMock: deviceServerSimulated,
} satisfies LabelPrinterClientProps) as LabelPrinterClient;

const receiptPrinterClient = printingService.buildClient(SupportedServices.ReceiptPrinter, {
  useMock: deviceServerSimulated,
} satisfies ReceiptPrinterClientProps) as ReceiptPrinterClient;

export const printLabel = async (receipt: Receipt): Promise<boolean> => {
  if (!receipt.template) {
    console.error('Missing receipt template name');
    return false;
  }

  try {
    return (
      await labelPrinterClient.print({
        label: receipt.template,
        printer: LabelAvailablePrinters.RoyalMail,
      })
    ).printed;
  } catch (err) {
    console.error('Failed to print', err);
    return false;
  }
};

export const printReceipt = async (
  receipt: Receipt,
  mode: ReceiptPrinterModes = ReceiptPrinterModes.Html,
  mockFormat: MockFormat = MockFormat.Image,
): Promise<boolean> => {
  if (!receipt.template) {
    console.error('Missing receipt template name');
    return false;
  }

  if (!receipt.context) {
    console.error('Missing receipt context');
    return false;
  }

  try {
    const compiledReceipt = await compile(receipt.template, receipt.context);
    const result = await receiptPrinterClient.print(compiledReceipt, mode, undefined, mockFormat);
    return result.result?.printed || false;
  } catch (err) {
    console.error('Failed to print', err);
    return false;
  }
};
